<template>
  <div>
    <i :class="['pi pi-ellipsis-h', $style.icon]" @click="handleMeatballClick" />
    <Popover ref="dropdownRef">
      <div v-for="option in dropdownOptions" :key="option.text" :class="$style.tooltipWrapper">
        <div :class="[$style.dropdownListItem, { [$style.disabledListItem]: option.disable }]" @click="option.callback">
          <VdIcon store="fas" :name="option.icon" size="large" color="#BCBEC1" />
          <span :class="$style.listItemText">{{ option.text }}</span>
        </div>
      </div>
    </Popover>
  </div>
</template>

<script setup>
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import Popover from "primevue/popover";
import { useConfirm } from "primevue/useconfirm";
import { computed, ref } from "vue";

const emit = defineEmits(["edit", "delete", "duplicate"]);
const props = defineProps({
  isEditable: {
    type: Boolean,
    default: false,
  },
});

const confirm = useConfirm();

const notWipText = "This version is not WIP, you cannot edit or delete this shop item";

const dropdownRef = ref();

const handleMeatballClick = (event) => {
  event.stopPropagation();
  dropdownRef.value.toggle(event);
};

const handleMenuOptionEvent = (event, eventToEmit = null) => {
  if (eventToEmit) {
    emit(eventToEmit);
  }
  dropdownRef.value.toggle(event);
};

const optionsIcons = {
  Edit: {
    icon: "fa-pencil",
    callback: (event) => {
      handleMenuOptionEvent(event, "edit");
    },
  },
  Duplicate: {
    icon: "fa-copy",
    callback: (event) => {
      handleMenuOptionEvent(event, "duplicate");
    },
  },
  Delete: {
    icon: "fa-trash",
    callback: (event) => {
      confirm.require({
        message: "Are you sure want to delete this shop item?",
        header: "Confirmation",
        rejectClass: "p-button-secondary p-button-outlined",
        acceptClass: "p-button-danger",
        acceptIcon: "pi pi-trash",
        rejectLabel: "Cancel",
        acceptLabel: "Delete",
        accept: () => {
          handleMenuOptionEvent(event, "delete");
        },
        reject: () => {
          handleMenuOptionEvent(event);
        },
      });
    },
  },
};

const dropdownOptions = computed(() => {
  const options = [
    { text: "Edit", disable: !props.isEditable },
    { text: "Duplicate", disable: !props.isEditable },
    {
      text: "Delete",
      disable: !props.isEditable,
      tooltipContent: notWipText,
    },
  ];
  return options.map((option) => ({
    text: option.text,
    icon: optionsIcons[option.text].icon,
    callback: optionsIcons[option.text].callback,
    disable: option.disable,
    tooltipContent: option.tooltipContent,
  }));
});
</script>

<style module>
.dropdownListItem {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  width: 240px;
  padding: 8px 8px;

  &:hover {
    background-color: var(--vd-color-neutral-light-10);
    cursor: pointer;
  }
}

.listItemText {
  font-size: 14px;
  color: var(--vd-color-text-light-2);
}

.disabledListItem {
  opacity: 0.5;
  pointer-events: none;
}

.icon {
  color: var(--vd-color-blue-default);
  font-weight: 900;
  font-size: 16px;
  cursor: pointer;
}

.tooltipWrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
